import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import Customers from '../../features/customers/Customers';
import CustomerDetails from '../../features/customers/CustomerDetails';
import AddCustomer from '../../features/customers/AddCustomer';
import CustomerGroups from '../../features/customers/CustomerGroups';
import CustomerGroupDetails from '../../features/customers/CustomerGroupDetails';
import NotFound from '../../common/components/router/NotFound';

const CustomerAppRoutes = () => (
  <Routes>
    <Route
      path="/search"
      element={
        <PrivateRoute permissions={[PERMISSIONS.UserRead]}>
          <Customers />
        </PrivateRoute>
      }
    />
    <Route
      path="/details/:customerId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.UserRead, PERMISSIONS.UserModify]}
        >
          <CustomerDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/addnew"
      element={
        <PrivateRoute permissions={[PERMISSIONS.UserModify]}>
          <AddCustomer />
        </PrivateRoute>
      }
    />
    <Route
      path="/customergroups/"
      element={
        <PrivateRoute permissions={[PERMISSIONS.UserRead]}>
          <CustomerGroups />
        </PrivateRoute>
      }
    />
    <Route
      path="/customergroups/details/:customergroupId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.UserRead, PERMISSIONS.UserModify]}
        >
          <CustomerGroupDetails />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default CustomerAppRoutes;
